module.exports = __webpack_public_path__ + "static/img-ac7e7a313fc5374297ee0d06835843b9.jpg";